import { useState, useEffect } from 'react'
import { TimeSeries } from '@scuf/charts'
import { Card } from '@scuf/common'
import { useDispatch } from 'react-redux'
import LineData from './LineData'
import LineDataAPI from './LineDataAPI'
import baseServices from '../../../services/base.services';
import { startLineChart } from '../../../actions/entryDataChart'
// import TitlePage from '../../../components/TitlePage/TitlePage';

const Line = ({ url, body, isCard, yAxisTitle, titleCard, randomSeries }) => {

    const dispatch = useDispatch();
    const [state, setState] = useState([])
    var j = 0

    useEffect(() => {

        var date = new Date();
        var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
            date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());


        const getData = async (j) => {

            try {

                if (body) {
                    var response = await baseServices.getDataN2(body[j], url);
                    if (response.data && response.data.length > 0) {

                        j == body.length - 1 ? j = 0 : j = j + 1

                        setState(LineDataAPI(response))
                        setTimeout(() => {
                            getData(j)
                        }, 30000);

                    }
                } else {
                    setState(LineData(randomSeries))
                    dispatch(startLineChart('dummy data'))
                    setTimeout(() => {
                        getData()
                    }, 150000);
                }

            } catch (err) {
                setTimeout(() => {
                    getData(j)
                }, 15000);
            }




        }

        getData(j)

    }, [])


    return (
        <>
            {
                isCard === '1' ?
                    <Card className='m-0'>
                        {/* <div className='mayus'>
                            <Card.Header title={titleCard} className='m-0 p-0'></Card.Header>
                        </div> */}
                        <Card.Content style={{ minHeight: '0px' }} className='m-0 p-0'>
                            <TimeSeries
                                showRangeSelector={false}
                                showScrollbar={false}
                                showNavigator={false}
                                height={160}
                            >
                                {
                                    state && state.map((y, i) => (
                                        <TimeSeries.Line spline={true} key={i} name={y.name} data={y.datos} color={y.color} />
                                    ))
                                }

                                <TimeSeries.Title text={titleCard} align='left' />
                                <TimeSeries.Legend enabled={true} align='right' verticalAlign='top' />
                                <TimeSeries.YAxis tickAmount={6} showGridLines={false} top="0%" height="100%" offset={-10} title={{ text: yAxisTitle }} labels={{ format: "" }} />


                            </TimeSeries>
                        </Card.Content>
                    </Card>
                    :
                    <div style={{ marginTop: "-15px" }}>
                        <TimeSeries
                            showRangeSelector={false}
                            showScrollbar={false}
                            showNavigator={false}
                            height={160}
                        >
                            {
                                state && state.map((y, i) => (
                                    <TimeSeries.Line spline={true} key={i} name={y.name} data={y.datos} color={y.color} />
                                ))
                            }

                            <TimeSeries.Title className='m-0' text={titleCard} align='left' />

                            <TimeSeries.Legend enabled={true} position='right middle' itemSpacing='small' layout='Vertical' itemStyle={{ "color": "#E0E0E0", "cursor": "pointer", "fontSize": "10px", "fontWeight": "bold", "textOverflow": "ellipsis" }} />
                            <TimeSeries.YAxis tickAmount={6} showGridLines={false} top="0%" height="100%" offset={-10} title={{ text: yAxisTitle }} labels={{ format: '' }} />

                        </TimeSeries>
                    </div>
            }
        </>


    )
}

export default Line
